'use client';

import Image from 'next/image';
import Link from 'next/link';
import {Input, Textarea} from '@delorand/ui/src/input';
import {InstagramSvg} from '@delorand/ui/src/svg/logo';
import {toast} from '@delorand/ui/src/toast';
import {zodResolver} from '@hookform/resolvers/zod';
import {client} from 'c/utils/api';
import {useForm} from 'react-hook-form';
import useSWRMutation from 'swr/mutation';
import {contactS, SToType} from '../../../../../../packages/schema/dto/shared';
import contactImage from '../../../../public/assets/contactImage.png';
import {fetchApi} from '../../../utils/misc';

const ContactPage = () => {
  return (
    <div className="mb-10 flex w-full flex-col items-center gap-8 p-4">
      <h3 className="mx-auto text-center text-2xl font-semibold md:pt-5">
        NEED HELP ?
      </h3>

      <Image
        alt="contact-image"
        src={contactImage}
        className="rounded-md bg-white/20"
      />

      {/* <button onClick={async () => await testFn()} className="text-white mt-10">
        Send
      </button> */}

      {/* <button
        onClick={() =>
          toast.promise(promise, {
            loading: "Loading...",
            success: (data: any) => {
              return `${data.name} toast has been added`;
            },
            error: "Error",
          })
        }
      >
        Toast
      </button> */}

      <div className="flex flex-col gap-6 rounded-[10px] bg-black py-5 text-center">
        <h3 className="text-center text-3xl font-bold">Get in touch</h3>
        <p className="mx-auto w-4/5 text-sm">
          Yes we are online. But we are not some distant entity somewhere. We
          are just a chat or phoneNumber call away from you.
        </p>
        <p className="mx-auto w-4/5 text-sm">
          Get in touch! Here’s how you can reach us....
        </p>

        <div className="pl-10 text-start">
          <h3>You can reach out directly:</h3>
          <a href="mailto:support@delorand.com" className="mt-2 font-medium">
            support@delorand.com
          </a>
          <p className="font-medium">09159114491</p>
        </div>

        <div className="flex items-center justify-center gap-5">
          <a
            target="_blank"
            rel="noreferrer"
            href="http://www.instagram.com/delorandhq"
          >
            <InstagramSvg width={50} height={50} />
          </a>

          {/* <a
            target='_blank'
            rel='noreferrer'
            href='http://www.facebook.com/delorandhq'>
            <FacebookSvg width={50} height={50} />
          </a> */}

          <a
            target="_blank"
            rel="noreferrer"
            href="http://www.twitter.com/delorandhq"
            className="h-[50px] w-[50px] rounded-full bg-white p-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
              width="40px"
              height="40px"
            >
              <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z" />
            </svg>
          </a>
        </div>
      </div>

      {/* <div className='bg-black rounded-[10px] flex flex-col gap-6 py-5 text-center'>
        <h3 className='text-center text-2xl font-bold'>Talk to cutomer care</h3>
        <p className='w-4/5 text-sm mx-auto'>
          We are always online on Whatsapp and just a message away from
          responding to you. Reach us now on Whatsapp
        </p>
      </div> */}

      <div className="flex flex-col gap-6 rounded-[10px] bg-black py-5 text-center">
        <h3 className="text-center text-2xl font-bold">FAQs</h3>
        <p className="mx-auto w-4/5 text-sm">
          Check the questions our customers always ask us. They could answer
          your questions too.
        </p>

        <Link href={'/help'} className="btn-full w-3/5 p-1.5 text-center">
          FAQs
        </Link>
      </div>

      <Form />

      <p className="">We are always here for you!!</p>
    </div>
  );
};

const Form = () => {
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm<SToType<typeof contactS>>({
    resolver: zodResolver(contactS),
  });

  const {trigger, data, isMutating} = useSWRMutation(
    ['contact.send'],
    (_, {arg}: {arg: SToType<typeof contactS>}) => {
      const promise = fetchApi(client.base['send-contact'].$post({json: arg}));
      toast.promise(promise, {
        loading: 'Sending...',
        success: 'Sent',
        error: 'Something went wrong!',
      });
      return promise;
    }
  );

  return (
    <div className="w-full p-5">
      {data ? (
        <div className="flex">
          <h4>
            {data.data.name?.split(' ')?.[0]}, Thank you for contacting
            Delorand. We have recieved your message and will get back to you as
            soon as possible!!
          </h4>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit(values => trigger(values))}
          className="flex w-full max-w-xl flex-col gap-4 rounded-[10px] bg-black"
        >
          <h3 className="text-center text-2xl font-bold">Speak to us</h3>
          <Input
            label="Your name"
            {...register('name')}
            error={errors.name?.message}
          />
          <Input
            type="email"
            label="Your email"
            {...register('email')}
            error={errors.email?.message}
          />
          <Input
            label="Subject"
            {...register('subject')}
            error={errors.subject?.message}
          />

          <Textarea
            label="Your message"
            rows={6}
            {...register('message')}
            error={errors.message?.message}
          />

          <button
            disabled={isMutating}
            type="submit"
            className="btn-white mt-4"
          >
            SUBMIT
          </button>
        </form>
      )}
    </div>
  );
};

export default ContactPage;
